import { track } from "@amplitude/analytics-browser";

class AmpliEvents {
  sendFullscreenEntry() {
    track("fullscreen_entry");
  }

  sendFullscreenExitClick() {
    track("fullscreen_exit_click ");
  }
}

export const ampliEvents = new AmpliEvents();
